import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ISchedule } from '~src/schedule/types/ISchedule';

export interface IGetUserIdentityMigrationBackgroundJobParams {
}

export interface IGetUserIdentityMigrationBackgroundJobResult extends IResult {
  schedule: ISchedule;
  isEnabled: boolean;
}

export class GetUserIdentityMigrationBackgroundJobRequest extends Request<IGetUserIdentityMigrationBackgroundJobParams, IGetUserIdentityMigrationBackgroundJobResult> {
  constructor(params: IGetUserIdentityMigrationBackgroundJobParams = {}) {
    super('getUserIdentityMigrationBackgroundJob', params);
  }
}
